import React from 'react';
import { ConsiderationLedger } from '../../../../../components/FlowOfFunds/ConsiderationLedger/ConsiderationLedger';
import { useFlowOfFunds } from '../useFlowOfFunds';

export interface OverallDealStructureSubTabProps {
    engagementId: number;
}

export const OverallDealStructureSubTab = (props: OverallDealStructureSubTabProps) => {
    const { flowOfFunds, isLoading } = useFlowOfFunds(props.engagementId);

    if (isLoading) {
        return <div className="mt-4 text-muted">Loading…</div>;
    }
    if (flowOfFunds?.consideration?.total?.faceValue == null) {
        return (
            <div className="mt-4 text-muted">
                No accepted LOI consideration is available for this engagement yet.
            </div>
        );
    }

    return (
        <div className="mt-4">
            <ConsiderationLedger
                consideration={flowOfFunds.consideration}
                engagementId={props.engagementId}
            />
        </div>
    );
};

export default OverallDealStructureSubTab;
